export const LEGAL_NATURE: Record<string, string> = {
	"1015": "Orgao Publico do Poder Executivo Federal",
	"1023": "Orgao Publico do Poder Executivo Estadual ou do Distrito Federal",
	"1031": "Orgao Publico do Poder Executivo Municipal",
	"1040": "Orgao Publico do Poder Legislativo Federal",
	"1058": "Orgao Publico do Poder Legislativo Estadual ou do Distrito Federal",
	"1066": "Orgao Publico do Poder Legislativo Municipal",
	"1074": "Orgao Publico do Poder Judiciario Federal",
	"1082": "Orgao Publico do Poder Judiciario Estadual",
	"1104": "Autarquia Federal",
	"1112": "Autarquia Estadual ou do Distrito Federal",
	"1120": "Autarquia Municipal",
	"1139": "Fundacao Federal",
	"1147": "Fundacao Estadual ou do Distrito Federal",
	"1155": "Fundacao Municipal",
	"1163": "Orgao Publico Autonomo da Uniao",
	"1171": "Orgao Publico Autonomo Estadual ou do Distrito Federal",
	"1180": "Orgao Publico Autonomo Municipal",
	"2011": "Empresa Publica",
	"2038": "Sociedade de Economia Mista",
	"2046": "Sociedade Anonima Aberta",
	"2054": "Sociedade Anonima Fechada",
	"2062": "Sociedade Empresaria Limitada",
	"2076": "Sociedade Empresaria em Nome Coletivo",
	"2089": "Sociedade Empresaria em Comandita Simples",
	"2097": "Sociedade Empresaria em Comandita por Acoes",
	"2100": "Sociedade Mercantil de Capital e Industria (extinta pelo NCC/2002)",
	"2127": "Sociedade Empresaria em Conta de Participacao",
	"2135": "Empresario (Individual)",
	"2143": "Cooperativa",
	"2151": "Consorcio de Sociedades",
	"2160": "Grupo de Sociedades",
	"2178": "Estabelecimento, no Brasil, de Sociedade Estrangeira",
	"2194": "Estabelecimento, no Brasil, de Empresa Binacional Argentino-Brasileira",
	"2208": "Entidade Binacional Itaipu",
	"2216": "Empresa Domiciliada no Exterior",
	"2224": "Clube/Fundo de Investimento",
	"2232": "Sociedade Simples Pura",
	"2240": "Sociedade Simples Limitada",
	"2259": "Sociedade em Nome Coletivo",
	"2267": "Sociedade em Comandita Simples",
	"2275": "Sociedade Simples em Conta de Participacao",
	"2305": "Empresa Individual de Responsabilidade Limitada",
	"3034": "Servico Notarial e Registral (Cartorio)",
	"3042": "Organizacao Social",
	"3050": "Organizacao da Sociedade Civil de Interesse Publico (Oscip)",
	"3069": "Outras Formas de Fundacoes Mantidas com Recursos Privados",
	"3077": "Servico Social Autonomo",
	"3085": "Condominio Edilicios",
	"3093": "Unidade Executora (Programa Dinheiro Direto na Escola)",
	"3107": "Comissao de Conciliacao Previa",
	"3115": "Entidade de Mediacao e Arbitragem",
	"3123": "Partido Politico",
	"3131": "Entidade Sindical",
	"3204": "Estabelecimento, no Brasil, de Fundacao ou Associacao Estrangeiras",
	"3212": "Fundacao ou Associacao Domiciliada no Exterior",
	"3999": "Outras Formas de Associacao",
	"4014": "Empresa Individual Imobiliaria",
	"4022": "Segurado Especial",
	"4081": "Contribuinte individual",
	"5002": "Organizacao Internacional e Outras Instituicoes Extraterritoriais",
};
